import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';

/**
 * Generated class for the PerguntaCompletaComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'pergunta-completa',
  templateUrl: 'pergunta-completa.html'
})
export class PerguntaCompletaComponent {

  text: string;

  constructor(params: NavParams) {
    console.log(' this.homePage = params.get(homePage);', params.get('pergunta_completa'));
    if(params.get('pergunta_completa')) this.text = params.get('pergunta_completa');
  }

}



// WEBPACK FOOTER //
// ./src/components/pergunta-completa/pergunta-completa.ts